import React, { Component } from 'react';
import Trending from '../Trending/Trending';
import { MODULE_VIEW_EVENT_OPTIONS } from '../Trending/events';

class TrendingCorridorDestinations extends Component {
  componentDidMount() {
    const { fetchTrendingCorridorDestinations, fullURL, siteName } = this.props;
    const queryStringStartIndex = fullURL.indexOf('?');
    const queryString = queryStringStartIndex >= 0
      ? `${fullURL.substring(queryStringStartIndex)}&site=${siteName}`
      : `?site=${siteName}`;
    fetchTrendingCorridorDestinations(queryString);
  }

  render() {
    const { showTrendingModal, data, title } = this.props;
    return Array.isArray(data) && data.length >= 5
      ? <Trending {...{ edapModuleViewEventOptions: MODULE_VIEW_EVENT_OPTIONS, showTrendingModal, data, title }} />
      : null;
  }
}

export default TrendingCorridorDestinations;
